import { mapGetters } from 'vuex'
import Fuse from 'fuse.js'
import rules from '@/mixins/rules'
import DepartmentsService from '@/services/DepartmentsService'

export default {
  mixins: [rules],
  watch: {
    locations () {
      this.engine.list = this.locations
    }
  },
  data () {
    return {
      engine: new Fuse([], {
        shouldSort: true,
        tokenize: false,
        includeScore: true,
        threshold: 0.3,
        keys: [{
          name: 'name',
          weight: 0.9
        }, {
          name: 'code',
          weight: 0.9
        }, {
          name: 'tags',
          weight: 0.8
        }]
      })
    }
  },
  computed: {
    ...mapGetters([
      'campuses',
      'categories',
      'locations'
    ])
  },
  mounted () {
    this.engine.list = this.locations
  },
  methods: {
    async search (input) {
      if (input === '') return []

      const output = []

      // Department search
      const departments = await this.loadDepartments(input)

      departments.departments.forEach(department => {
        if (this.convertScore(department.SearchScore) <= this.engine.options.threshold) {
          const location = this.locations.filter(location => {
            return location.code === department.Building
          })[0]

          if (location && !output.includes(location)) output.push(location)
        }
      })

      // Fuse search
      const searchOutput = await this.engine.search(input)

      searchOutput.forEach(item => {
        const location = item.item

        if (location && !output.includes(location)) output.push(location)
      })

      return output
    },
    async loadDepartments (input) {
      const response = await DepartmentsService.getDepartmentsByName(input)
      return response
    },
    convertScore (input) {
      return 1 - (input / 10000)
    }
  }
}
